<template>
  <div class="doge-shell">
    <header class="doge-top"><button class="doge-back" @click="$router.back()">‹</button><h1 class="doge-title">充值</h1><div class="doge-placeholder"></div></header>
    <main class="doge-page-pad">
      <section class="deposit-top">
        <label>充值到账金额</label>
        <div><input v-model="amount" type="number" placeholder="输入到账USDT金额" @input="preview"><span>USDT</span></div>
        <p>系统按当前DOGE/USDT价格计算需支付DOGE数量，点击确认后将直接拉起绑定钱包完成支付。</p>
      </section>
      <section class="doge-card">
        <div class="doge-row"><span>充值网络</span><b>{{ config.chain || 'BSC' }}</b></div>
        <div class="doge-divider"></div>
        <div class="doge-row"><span>绑定付款钱包</span><b>{{ short(walletAddress) || '请先连接钱包' }}</b></div>
        <div class="doge-row"><span>支付币种</span><b>BSC DOGE</b></div>
        <div class="doge-row"><span>最低充值</span><b>{{ money(config.min_amount) }} USDT</b></div>
        <div class="doge-row"><span>确认数</span><b>{{ config.required_confirmations || 12 }} 个区块</b></div>
      </section>
      <section class="doge-card" v-if="previewData">
        <div class="preview-row"><span>DOGE价格</span><b>{{ money(previewData.doge_price) }} USDT</b></div>
        <div class="preview-row"><span>到账金额</span><b>{{ money(previewData.usdt_amount) }} USDT</b></div>
        <div class="preview-row"><span>需支付DOGE</span><b class="doge-status-orange">{{ doge(previewData.doge_amount) }} DOGE</b></div>
        <p class="hint">价格以创建订单时锁定为准，订单有效期约 {{ previewData.expire_minutes || 15 }} 分钟。</p>
      </section>
      <section class="doge-card">
        <button class="doge-btn full" :disabled="submitting" @click="submit">{{ submitting ? '钱包处理中...' : '确认并唤起钱包支付' }}</button>
        <button class="record-link" @click="$router.push({name:'billList',query:{type:'1'}})">充值记录</button>
      </section>
    </main>
    <BottomNav/>
  </div>
</template>
<script>
import BottomNav from '../../components/layout/BottomNav.vue';
import { mapGetters } from 'vuex';
import { ethers } from 'ethers';
const ERC20_ABI = ['function transfer(address to,uint256 amount) returns (bool)', 'function balanceOf(address account) view returns (uint256)', 'function decimals() view returns (uint8)', 'function symbol() view returns (string)'];
const ERC20_IFACE = new ethers.utils.Interface(ERC20_ABI);
export default {
  name: 'deposit',
  components: { BottomNav },
  data() { return { amount: '', config: {}, previewData: null, previewTimer: null, submitting: false }; },
  computed: {
    ...mapGetters(['getWalletAddress']),
    walletAddress() { return this.getWalletAddress || ''; },
    canPay() { return this.amount && this.previewData && this.walletAddress && (this.config.to_address || this.config.address) && this.config.token_contract; }
  },
  mounted() { this.load(); },
  methods: {
    async load() {
      try {
        const r = await this.$axios.get('/api/doge/deposit_config');
        this.config = r.data.data || {};
      } catch (e) { this.config = {}; }
    },
    preview() { clearTimeout(this.previewTimer); if (!this.amount || Number(this.amount) <= 0) { this.previewData = null; return; } this.previewTimer = setTimeout(this.fetchPreview, 350); },
    async fetchPreview() {
      try { const r = await this.$axios.get('/api/doge/deposit_preview', { params: { amount: this.amount } }); this.previewData = r.data.data || null; }
      catch (e) { this.previewData = null; }
    },
    async ensureBscNetwork() {
      const targetChainId = '0x38';
      const current = await window.ethereum.request({ method: 'eth_chainId' });
      if (String(current).toLowerCase() === targetChainId) return;
      try {
        await window.ethereum.request({ method: 'wallet_switchEthereumChain', params: [{ chainId: targetChainId }] });
      } catch (e) {
        if (e && e.code === 4902) {
          await window.ethereum.request({
            method: 'wallet_addEthereumChain',
            params: [{
              chainId: targetChainId,
              chainName: 'BNB Smart Chain',
              nativeCurrency: { name: 'BNB', symbol: 'BNB', decimals: 18 },
              rpcUrls: ['https://bsc-dataseed.binance.org/'],
              blockExplorerUrls: ['https://bscscan.com/']
            }]
          });
        } else {
          throw new Error('请切换到BSC网络后再充值');
        }
      }
    },
    async submit() {
      if (!this.amount || Number(this.amount) <= 0) return this.msg('请输入要充值的金额');
      if (!window.ethereum) return this.msg('请先安装或打开钱包');
      if (!this.walletAddress) {
        try {
          const accounts = await window.ethereum.request({ method: 'eth_requestAccounts' });
          if (accounts && accounts[0]) this.$store.dispatch('updateWalletAddress', accounts[0]);
        } catch (e) {
          return this.msg('请先连接绑定钱包');
        }
      }
      if (!this.getWalletAddress) return this.msg('请先连接绑定钱包');
      if (!this.config.token_contract) return this.msg('DOGE合约未配置');
      if (!(this.config.to_address || this.config.address)) return this.msg('系统收款地址未配置');
      this.submitting = true;
      try {
        await this.ensureBscNetwork();
        await this.fetchPreview();
        const fromAddress = this.getWalletAddress || this.walletAddress;
        await this.$store.dispatch('ensureDogeAuth');
        const orderRes = await this.$axios.post('/api/doge/deposit', { amount: this.amount, from_address: fromAddress });
        if (![1, 200].includes(Number(orderRes.data.code))) throw new Error(orderRes.data.message || orderRes.data.msg || '充值订单创建失败，请稍后再试');
        const order = orderRes.data.data || {};
        const to = order.to_address || order.address || this.config.to_address || this.config.address;
        const dogeAmount = order.doge_amount || this.previewData.doge_amount;
        if (!ethers.utils.isAddress(to)) throw new Error('系统收款地址配置不正确');
        if (!ethers.utils.isAddress(this.config.token_contract)) throw new Error('DOGE合约地址配置不正确');
        const provider = new ethers.providers.Web3Provider(window.ethereum);
        const signerAddress = await provider.getSigner().getAddress();
        if (String(signerAddress).toLowerCase() !== String(fromAddress).toLowerCase()) {
          throw new Error('当前钱包地址与绑定付款钱包不一致：当前 ' + this.short(signerAddress) + '，绑定 ' + this.short(fromAddress));
        }
        const token = new ethers.Contract(this.config.token_contract, ERC20_ABI, provider);
        let decimals = Number(this.config.token_decimals || this.previewData.token_decimals || 8);
        let symbol = 'DOGE';
        try { decimals = Number(await token.decimals()); } catch (e) {}
        try { symbol = await token.symbol(); } catch (e) {}
        const dogeRaw = ethers.utils.parseUnits(String(dogeAmount), decimals);
        const balanceRaw = await token.balanceOf(fromAddress);
        if (balanceRaw.lt(dogeRaw)) {
          const current = ethers.utils.formatUnits(balanceRaw, decimals);
          throw new Error(symbol + '余额不足：本次需支付 ' + this.doge(dogeAmount) + ' ' + symbol + '，当前钱包约 ' + this.doge(current) + ' ' + symbol + '。请确认钱包在BSC链，并且余额是合约 ' + this.short(this.config.token_contract) + ' 的余额。');
        }
        const data = ERC20_IFACE.encodeFunctionData('transfer', [to, dogeRaw]);
        const txHash = await window.ethereum.request({
          method: 'eth_sendTransaction',
          params: [{ from: fromAddress, to: this.config.token_contract, data, value: '0x0' }]
        });
        await this.$axios.post('/api/doge/deposit/tx', { id: order.id, tx_hash: txHash });
        this.msg('支付已提交，等待链上确认到账', 'success');
        this.amount = '';
        this.previewData = null;
        this.$router.push({ name: 'billList', query: { type: '1' } });
      } catch (e) {
        this.msg((e.response && e.response.data && (e.response.data.message || e.response.data.msg)) || e.message || '充值提交没有成功，请稍后再试', 'error');
      } finally { this.submitting = false; }
    },
    short(v) { v = (v || '').toString(); return v.length > 18 ? v.slice(0, 10) + '...' + v.slice(-8) : v; },
    money(v) { return Number(v || 0).toFixed(2); },
    doge(v) { return Number(v || 0).toFixed(8); },
    msg(t, type = 'info') { this.$messageDialog ? this.$messageDialog.alert(t, '提示', type) : alert(t); }
  }
};
</script>
<style scoped>.deposit-top{background:#fff6d8;border-radius:18px;padding:18px;color:#211507;border:1px solid #ead9b6}.deposit-top label{font-size:18px;font-weight:800}.deposit-top div{margin:16px 0;display:flex;align-items:center;background:#fff;border-radius:12px;padding:0 14px;border:1px solid #ead9b6}.deposit-top input{height:50px;flex:1;border:0;background:transparent;color:#211507;outline:none}.deposit-top p{color:#8b806d;line-height:1.6;font-size:13px}.doge-row{min-height:38px}.doge-row b{color:#d39b2c;text-align:right;word-break:break-all}.preview-row{display:flex;justify-content:space-between;gap:12px;padding:9px 0;color:var(--doge-muted)}.preview-row b{color:#211507;text-align:right}.hint{color:#8b806d;font-size:13px;line-height:1.6}.record-link{margin-top:10px;border:0;background:transparent;color:var(--doge-primary);font-weight:700;width:100%}</style>
